/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalAdminWhitelabelRequestV4SslCertificateDataFromJSON, InternalAdminWhitelabelRequestV4SslCertificateDataToJSON, } from './InternalAdminWhitelabelRequestV4SslCertificateData';
/**
 * Check if a given object implements the InternalAdminWhitelabelRequestV4 interface.
 */
export function instanceOfInternalAdminWhitelabelRequestV4(value) {
    if (!('clientFqdn' in value) || value['clientFqdn'] === undefined)
        return false;
    if (!('sslCertificateData' in value) || value['sslCertificateData'] === undefined)
        return false;
    return true;
}
export function InternalAdminWhitelabelRequestV4FromJSON(json) {
    return InternalAdminWhitelabelRequestV4FromJSONTyped(json, false);
}
export function InternalAdminWhitelabelRequestV4FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'clientFqdn': json['client_fqdn'],
        'sslCertificateData': InternalAdminWhitelabelRequestV4SslCertificateDataFromJSON(json['ssl_certificate_data']),
    };
}
export function InternalAdminWhitelabelRequestV4ToJSON(json) {
    return InternalAdminWhitelabelRequestV4ToJSONTyped(json, false);
}
export function InternalAdminWhitelabelRequestV4ToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'client_fqdn': value['clientFqdn'],
        'ssl_certificate_data': InternalAdminWhitelabelRequestV4SslCertificateDataToJSON(value['sslCertificateData']),
    };
}
